<template>
  <div class="news-category">
    <div class="container">
      <Headline v-if="resource.columns.title" v-editable="resource.columns.title" class="news-category__title" />
      <Wysiwyg class="news-category__text">
        <div v-editable="resource.columns.text" />
      </Wysiwyg>
      <div class="news-category__content">
        <template v-if="news && news.length">
          <NewsCategoryItem v-for="item in news" :key="item.id" :resource="item" />
        </template>
        <template v-else>
          <Wysiwyg class="news-category__text">
            Derzeit gibt es leider keine Einträge in dieser Kategorie.
          </Wysiwyg>
        </template>
      </div>
      <p v-if="!showAll && hasMore && resource.columns.load_more" class="news-category__load-more" @click="loadAll">
        Mehr...
      </p>
    </div>
  </div>
</template>

<script>
import { chain } from 'lodash'
import { News } from 'beisheim/models'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import NewsCategoryItem from 'beisheim/components/blocks/news-category-item'
import Headline from 'beisheim/components/elements/headline'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'

export default {
  components: {
    Headline,
    Wysiwyg,
    NewsCategoryItem
  },
  mixins: [ editable ],
  data () {
    return {
      showAll: false
    }
  },
  computed: {
    news () {
      const news = News.all()
      return chain(news)
        .orderBy(['columns.date'], ['desc'])
        .filter(n => n.columns.category === this.resource.columns.category)
        .filter(r => r.country === this.$country && r.language === this.$language)
        .filter(r => !r.name.startsWith('_'))
        .take(this.resource.columns.max || 3)
        .value()
    },
    hasMore () {
      const news = News.all()
      const all = chain(news)
        .filter(n => n.columns.category === this.resource.columns.category)
        .filter(r => r.country === this.$country && r.language === this.$language)
        .filter(r => !r.name.startsWith('_'))
        .value()

      return all.length > this.news.length
    }
  },
  methods: {
    loadAll () {
      this.showAll = true
    }
  }
}
</script>

<style lang="scss">
@import "~beisheim/scss/font";

  .news-category {
    margin-top: 2rem;
    margin-bottom: 2rem;

    &__text {
      @include font(1);
    }

    &__content {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    &__load-more {
      @include font(2);
      text-align: center;
      text-decoration: underline;
      cursor: pointer;
      margin-top: 2rem;
      margin-bottom: 2rem;
    }
  }
</style>
